mch365.admin = {
    jMainContainer: null,
    init: function () {
        if (jQuery('.js-mch365-container').length > 0 || jQuery('.js-mch365-form').length > 0) {
            e4.require.js(e4.settings.require.jQueryValidate, function () {
                mch365.admin.jMainContainer = jQuery('.js-mch365-container');
                mch365.admin.validationRules.bind();
                mch365.admin.build();
                mch365.admin.bindEvents();
                mch365.admin.form.bindEvents();
                mch365.admin.ui.init();
                mch365.admin.notification.init();
                mch365.admin.links.init();
            });
        } else if (jQuery('.js-mch365-login-form').length > 0){
            e4.require.js(e4.settings.require.jQueryValidate, function () {
                mch365.admin.validationRules.bind();
            });
        }
    },
    notification: {
        init: function () {
            if (jQuery('.js-mch365-section-closebutton').length > 0) {
                mch365.admin.notification.bindEvents();
            }
            if (jQuery('.js-mch365-closed-notifications-page').length > 0) {
                mch365.admin.notification.sanitizeClosedNotificationSections();
            }
        },
        bindEvents: function () {
            mch365.admin.jMainContainer.on('click', '.js-mch365-section-closebutton', function (event) {
                event.preventDefault();
                var jElement = jQuery(event.currentTarget),
                    jForm = jElement.closest('form'),
                    jInput = jForm.find('textarea[name="User.NotificationSectionIds"]'),
                    jqXHR = jQuery.ajax({
                        type: 'POST',
                        method: 'POST',
                        url: '/system/data/mch?Action=userdetail',
                        dataType: 'json',
                        enctype: 'multipart/form-data',
                        processData: false,
                        contentType: false,
                        cache: false,
                        beforeSend: function () {

                        }
                    });

                jqXHR.done(function (data) {
                    var strUserNotificationSectionIds = data.User.NotificationSectionIds,
                        jsonNotificationSectionIds = {};

                    strUserNotificationSectionIds = strUserNotificationSectionIds.split('&quot;').join('"');

                    if (mch365.admin.ui.isJson(strUserNotificationSectionIds)) {
                        jsonNotificationSectionIds = jQuery.parseJSON(strUserNotificationSectionIds);
                    }

                    if (jsonNotificationSectionIds['sectionIds'] === undefined) {
                        jsonNotificationSectionIds.sectionIds = [];
                    }

                    if (jsonNotificationSectionIds.sectionIds.indexOf(jInput.val()) === -1) {
                        jsonNotificationSectionIds.sectionIds.push(jInput.val());
                    }
                    jInput.val(JSON.stringify(jsonNotificationSectionIds));
                    jForm.submit();
                    jElement.closest('section').remove();
                });
            });
        },
        sanitizeClosedNotificationSections: function () {
            jQuery('.js-mch365-closed-notifications-page').find('.js-mch365-section-closebutton').each(function (intIndex, domElement) {
                jQuery(domElement).closest('section').removeClass('d-none');
                jQuery(domElement).closest('form').remove();
            });
        }
    },
    ui: {
        isJson: function (strValue) {
            try {
                JSON.parse(strValue);
            } catch (e) {
                return false;
            }
            return true;
        },
        init: function () {
            mch365.admin.ui.navigationObserver.bindEvents();
        },
        navigationObserver: {
            formIsChangedButNotSaved: false,
            currentActiveForm: null,
            currentLinkElement: null,
            bindEvents: function () {
                jQuery(document).on('click', 'a', function (event) {
                    var isInsideMCHcontainer = jQuery(event.target).closest('.js-mch365-container').length > 0;
                    mch365.admin.ui.navigationObserver.currentLinkElement = event.currentTarget;
                    if (mch365.admin.ui.navigationObserver.formIsChangedButNotSaved && mch365.admin.ui.navigationObserver.currentActiveForm !== null && isInsideMCHcontainer === false) {
                        event.preventDefault();
                        mch365.admin.ui.prompt.dialog.confirm({}, function () {
                            jQuery(mch365.admin.ui.navigationObserver.currentActiveForm).submit()
                        }, []);
                    }
                });
            }
        },
        modal: {
            hide: function (jModal) {
                jModal.modal('hide');
                jQuery('body').removeClass('modal-open');
                jQuery('.modal-backdrop').remove();
            }
        },
        prompt: {
            dialog: {
                show: function () {
                    //success, warning, info, alert
                    confirm('Er du sikker?');
                },
                error: function (objConfirmOptions, fnCallbackAccept, arrCallbackArgs) {
                    var objDefaults = {},
                        objOptions = Object.assign({}, objDefaults, objConfirmOptions),
                        jModal = jQuery('#mch365-modal-error');
                    return new Promise(function (resolve, reject) {
                        jModal.on('click', '.js-mch365-accept-btn', function () {
                            resolve(fnCallbackAccept);
                            mch365.admin.ui.modal.hide(jModal);
                        }).on('click', '.js-mch365-deny-btn', function (event) {
                            reject();
                        }).modal('show');
                    }).then(function (fnResolvedCallback) {
                        if (typeof fnResolvedCallback === 'function') {
                            var arrResolvedArgs = Array.prototype.slice.call(arrCallbackArgs || [], 0)
                            fnResolvedCallback.apply(this, arrResolvedArgs);
                        }
                    }).catch(function () {
                    });
                },
                confirm: function (objConfirmOptions, fnCallbackAccept, arrCallbackArgs) {
                    var objDefaults = {},
                        objOptions = Object.assign({}, objDefaults, objConfirmOptions),
                        jModal = jQuery('#mch365-modal-warning');
                    return new Promise(function (resolve, reject) {
                        var jModal = jQuery('#mch365-modal-warning');
                        jModal.on('click', '.js-mch365-accept-btn', function () {
                            resolve(fnCallbackAccept);
                            mch365.admin.ui.modal.hide(jModal);
                        }).on('click', '.js-mch365-deny-btn', function (event) {
                            reject();
                        }).modal('show');
                    }).then(function (fnResolvedCallback) {
                        if (typeof fnResolvedCallback === 'function') {
                            var arrResolvedArgs = Array.prototype.slice.call(arrCallbackArgs || [], 0)
                            fnResolvedCallback.apply(this, arrResolvedArgs);
                        }
                    }).catch(function () {
                        mch365.admin.ui.modal.hide(jModal);
                        location.href = mch365.admin.ui.navigationObserver.currentLinkElement.href;
                    });
                },
                confirmOrder: function (objConfirmOptions, fnCallbackAccept, arrCallbackArgs) {
                    var objDefaults = {},
                        objOptions = Object.assign({}, objDefaults, objConfirmOptions),
                        jModal = jQuery('#mch365-modal-confirm-order');
                    return new Promise(function (resolve, reject) {
                        var jModal = jQuery('#mch365-modal-confirm-order');
                        jModal.on('click', '.js-mch365-accept-btn', function () {
                            resolve(fnCallbackAccept);
                            mch365.admin.ui.modal.hide(jModal);
                        }).on('click', '.js-mch365-deny-btn', function (event) {
                            reject();
                        }).modal('show');
                    }).then(function (fnResolvedCallback) {
                        if (typeof fnResolvedCallback === 'function') {
                            var arrResolvedArgs = Array.prototype.slice.call(arrCallbackArgs || [], 0)
                            fnResolvedCallback.apply(this, arrResolvedArgs);
                        }
                    }).catch(function () {
                        mch365.admin.ui.modal.hide(jModal);
                        location.href = mch365.admin.ui.navigationObserver.currentLinkElement.href;
                    });
                },
                confirmDelete: function (objConfirmOptions, fnCallbackAccept, arrCallbackArgs) {
                    var objDefaults = {},
                        objOptions = Object.assign({}, objDefaults, objConfirmOptions),
                        jModal = jQuery('#mch365-modal-delete');
                    return new Promise(function (resolve, reject) {
                        var jModal = jQuery('#mch365-modal-delete');
                        jModal.on('click', '.js-mch365-accept-btn', function () {
                            resolve(fnCallbackAccept);
                            mch365.admin.ui.modal.hide(jModal);
                        }).on('click', '.js-mch365-deny-btn', function (event) {
                            reject();
                        }).modal('show');
                    }).then(function (fnResolvedCallback) {
                        if (typeof fnResolvedCallback === 'function') {
                            var arrResolvedArgs = Array.prototype.slice.call(arrCallbackArgs || [], 0)
                            fnResolvedCallback.apply(this, arrResolvedArgs);
                        }
                    }).catch(function () {
                        mch365.admin.ui.modal.hide(jModal);
                    });
                }
            }
        },
        isEllipsisActive: function (domElement) {
            return domElement.offsetWidth < domElement.scrollWidth;
        }
    },
    links:{
        linkElements: null,
        init: function () {
            if (mch365.admin.jMainContainer.find('.js-mch365-link')){
                mch365.admin.links.linkElements = mch365.admin.jMainContainer.find('.js-mch365-link');
                mch365.admin.links.sanitize();
                mch365.admin.links.bindEvents();
            }
        },
        bindEvents: function () {
            jQuery( window ).on( 'resize', e4.util.debounce( mch365.admin.links.sanitize, e4.settings.debounceDelay.resize ) );
        },
        sanitize: function () {
            const ellipsisLinks = mch365.admin.links.linkElements.filter('.js-mch365-link-ellipsis');
            ellipsisLinks.removeClass('d-none');
            ellipsisLinks.each(function (intIndex, domElement) {
                const jElement = jQuery(domElement);
                const ellipsisableElementParent = mch365.admin.jMainContainer.find('[id="'+jElement.attr('aria-controls')+'"]');
                if (ellipsisableElementParent.hasClass('show') === false) {
                    const ellipsisableElement = ellipsisableElementParent.children(':first')[0];
                    if (mch365.admin.ui.isEllipsisActive(ellipsisableElement) === false){
                        jElement.addClass('d-none');
                    }
                }
            });
        }
    },
    validationRules: {
        bind: function () {
            jQuery.validator.addMethod("js-validate-email", function(value, element) {
                return this.optional(element) || /^[a-zA-Z0-9._%+-]+@[a-zA-ZæøåÆØÅ0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
            }, "Please enter a valid email address.");
            
            jQuery.validator.addClassRules('js-validate-depends-on-checkbox', {
                required: function (domElement) {
                    var jElement = jQuery(domElement),
                        jElementsValidateDependsOn = mch365.admin.jMainContainer.find(jElement.data('validateDependsOn'));
                    return jElementsValidateDependsOn.filter(':checked').length > 0;
                }
            });

            jQuery.validator.addClassRules('js-validate-group-of-fields', {
                required: function (domElement) {
                    var jElement = jQuery(domElement);
                    var validationFields = jElement.closest('.form-group').find('input').filter(':not(.js-validate-group-of-fields)').filter(':not(.js-mch365-exclude-group-validation)');
                    return validationFields.length === 0 ? false : validationFields.filter(':checked').length === 0;
                }
            });

            jQuery.validator.addClassRules('js-validate-depends-on-select', {
                required: function (domElement) {
                    var jElement = jQuery(domElement);
                    var jSelect = jQuery('select[id="' + jElement.data('validateDependsOnSelectId') + '"]');
                    return jSelect.val() !== '';
                }
            });
        }
    },
    submit: {
        form: function (domForm, event) {
            event.preventDefault();
            jQuery(event.target).find('.js-mch365-dynamic-placeholder').remove();
            var formData = new FormData(domForm);


            if (formData.get('Event.StartDate') !== null) {
                if (formData.get('Event.StartDate').length === 0) {
                    formData.delete('Event.StartDate');
                }
            }
            if (formData.get('Event.EndDate') !== null) {
                if (formData.get('Event.EndDate').length === 0) {
                    formData.delete('Event.EndDate');
                }
            }

            if (formData.get('Presentation.Companies') !== null) {
                var strCompanies = formData.getAll('Presentation.Companies').filter(function (value, index) {
                    return value.trim().length > 0;
                }).join('[|]');
                formData.delete('Presentation.Companies');
                formData.append('Presentation.Companies', strCompanies);
            }

            if (formData.get('Presentation.Trademarks') !== null) {
                var strTrademarks = formData.getAll('Presentation.Trademarks').filter(function (value, index) {
                    return value.trim().length > 0;
                }).join('[|]');
                formData.delete('Presentation.Trademarks');
                formData.append('Presentation.Trademarks', strTrademarks);
            }
            mch365.admin.post(event, formData);
        },
        actionForm: function (domForm, event) {
            event.preventDefault();
            jQuery(event.target).find('.js-mch365-dynamic-placeholder').remove();
            var formData = new FormData(domForm);

            if (formData.get('Presentation.Companies') !== null) {
                var strCompanies = formData.getAll('Presentation.Companies').filter(function (value, index) {
                    return value.trim().length > 0;
                }).join('[|]');
                formData.delete('Presentation.Companies');
                formData.append('Presentation.Companies', strCompanies);
            }

            if (formData.get('Presentation.Trademarks') !== null) {
                var strTrademarks = formData.getAll('Presentation.Trademarks').filter(function (value, index) {
                    return value.trim().length > 0;
                }).join('[|]');
                formData.delete('Presentation.Trademarks');
                formData.append('Presentation.Trademarks', strTrademarks);
            }
            mch365.admin.refresh(event, formData);
        }

    },
    bindEvents: function () {
        mch365.admin.jMainContainer.on('input', '.js-mch365-form,.js-mch365-action-form', function (event) {
            mch365.admin.ui.navigationObserver.formIsChangedButNotSaved = true;
            mch365.admin.ui.navigationObserver.currentActiveForm = event.currentTarget;
        });

        mch365.admin.jMainContainer.on('input', '.js-e-search-input', e4.util.debounce(function (event) {
            mch365.admin.toggleInputGroupState(event.target);
            //jQuery( event.target ).closest( '.js-e-extranet-impersonatable-users-search-form' ).triggerHandler(
            // 'submit' );
        }, e4.settings.debounceDelay.input));

        mch365.admin.jMainContainer.on('click', '.js-e-search-clear', function (event) {
            mch365.admin.clearInput(event.target);
        });

        /*bindEvents: function () {
         jQuery( '.js-e-extranet-impersonatable-users-search-form' ).on( 'submit', function ( event ) {
         event.preventDefault();
         e4.impersonation.search( jQuery( event.target ).find( '.js-e-extranet-impersonatable-users-search-input' ).get( 0 ) );
         } );
         jQuery( '.js-e-extranet-impersonatable-users-search-input' ).on( 'input', e4.util.debounce( function ( event ) {
         e4.impersonation.toggleInputGroupState( event.target );
         jQuery( event.target ).closest( '.js-e-extranet-impersonatable-users-search-form' ).triggerHandler( 'submit' );
         }, e4.settings.debounceDelay.input ) );
         jQuery( '.js-e-extranet-impersonatable-users-search-clear' ).on( 'click', function ( event ) {
         e4.impersonation.clearInput( event.target );
         } );
         },
         toggleInputGroupState: function ( domElm ) {
         var jSearchInputGroup = jQuery( domElm ).closest( '.js-e-extranet-impersonatable-users-search-input-group' );
         if ( domElm.value === '' ) {
         jSearchInputGroup.addClass( 'is-empty' );
         }
         else {
         jSearchInputGroup.removeClass( 'is-empty' );
         }
         },
         clearInput: function ( domElm ) {
         jQuery( domElm ).closest( '.js-e-extranet-impersonatable-users-search-input-group' ).find( '.js-e-extranet-impersonatable-users-search-input' ).val( '' ).trigger( 'focus' ).triggerHandler( 'input' );
         sessionStorage.removeItem( 'e4.impersonation.searchQuery' );
         }*/

        mch365.admin.jMainContainer.on('submit', '.js-mch365-target-form', function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            var formData = new FormData(event.currentTarget),
                jForm = jQuery(event.currentTarget),
                jTargetElement = jQuery(jForm.data('target')),
                addonParams = '';

            formData.forEach(function (value, key) {
                addonParams = addonParams + '&' + key + '=' + encodeURIComponent(value);
            });

            if (jTargetElement.data('originalFeedUrl') === undefined) {
                jTargetElement.data('originalFeedUrl', jTargetElement.data('feedUrl'));
            }

            jTargetElement.find('*[data-input="pageNum"]').val('1');
            jTargetElement.data('feedUrl', jTargetElement.data('originalFeedUrl') + addonParams);
            mch365.admin.load(jTargetElement[0]);
        });
    },
    toggleInputGroupState: function (domElm) {
        var jSearchInputGroup = jQuery(domElm).closest('.js-e-search-input-group');
        if (domElm.value === '') {
            jSearchInputGroup.addClass('is-empty');
        } else {
            jSearchInputGroup.removeClass('is-empty');
        }
    },
    clearInput: function (domElm) {
        jQuery(domElm).closest('.js-e-search-input-group').find('.js-e-search-input').val('').trigger('focus');
        mch365.admin.toggleInputGroupState(jQuery(domElm).closest('.js-e-search-input-group').find('.js-e-search-input')[0]);
        jQuery(domElm).closest('.js-mch365-target-form').submit();
    },
    form: {
        bindEvents: function () {
            mch365.admin.jMainContainer.on('click', '.js-mch365-sort-handler', function (event) {
                event.preventDefault();
                mch365.admin.form.sortList(event);
                return false;
            });
            mch365.admin.jMainContainer.on('click', '.js-mch365-paging-nav-item', function (event) {
                event.preventDefault();
                mch365.admin.form.setPaging(event);
                return false;
            });
            mch365.admin.jMainContainer.on('click', '.js-mch365-form-edit', function (event) {
                var jElementRow = jQuery(event.target).closest('.js-mch365-table-row');
                mch365.admin.form.populateEditFormContainer(jElementRow);
            });

            mch365.admin.jMainContainer.on('click', '.js-mch365-row-content', function (event) {
                if (jQuery(event.target).closest('.mch365-table-row-action-buttons').length === 0) {
                    var jElementRow = jQuery(event.currentTarget).closest('.js-mch365-table-row');
                    mch365.admin.form.populateEditFormContainer(jElementRow);
                }
            });

            mch365.admin.jMainContainer
                .on('click', '.js-mch365-btn-regret', function (event) {
                    event.preventDefault();
                    var jCollapseContainer = jQuery(event.target).closest('.collapse.show');
                    if (jCollapseContainer.length === 0){
                        var jElementRow = jQuery(event.target).closest('.js-mch365-table-row'),
                            jForm = jElementRow.find('.js-mch365-row-form');
                        jForm.removeClass('d-block').addClass('d-none');
                        jElementRow.removeClass('mch365-form-shown');
                        jForm.find('.js-mch365-placeholder').empty();
                        jElementRow.find('.js-mch365-row-content').removeClass('d-none');
                    } else {
                        jCollapseContainer.collapse('hide');
                    }
                })
                .on('click', '.js-mch365-btn-publish', function(event){
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    var jForm = jQuery(event.target).closest('form');
                    jForm.find('.js-mch365-input-visible').prop('checked', true);
                    jForm.submit();
                })
                .on('click', '.js-mch365-btn-draft', function(event){
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    var jForm = jQuery(event.target).closest('form');
                    jForm.find('.js-mch365-input-visible').prop('checked', false);
                    jForm.submit();
                });

            mch365.admin.jMainContainer.on('click', '.js-mch365-add-dynamic-content', function (event) {
                var jElementPlaceholder = jQuery(event.target).closest('.js-mch365-dynamic-group').children('.js-mch365-dynamic-placeholder').first(),
                    jElementContainer = jQuery(event.target).closest('.js-mch365-dynamic-group').children('.js-mch365-dynamic-container').first(),
                    containPlaceholders = jElementPlaceholder.hasClass('js-mch365-contains-placeholders'),
                    jClonedElement = jElementPlaceholder.clone();

                if (containPlaceholders) {
                    var jElementLast = jElementContainer.children('.js-mch365-dynamic-container-element').last(),
                        oneUpCount = jElementLast.data('oneUpCount');

                    jQuery.each(jElementLast.data(), function (key, value) {
                        value = (isNaN(value) && key != 'oneUpCount') || key.indexOf('{{') > -1 ? 1 : value;
                        value = key.indexOf(oneUpCount) > -1 ? ++value : value;
                        jClonedElement.data(key, value);
                        jClonedElement.html(jClonedElement.html().split('{{' + key + '}}').join(value));
                    });

                    jQuery.each(jClonedElement.data(), function (key, value) {
                        value = (isNaN(value) && key != 'oneUpCount') || key.indexOf('{{') > -1 ? 1 : value;
                        value = key.indexOf(oneUpCount) > -1 ? ++value : value;
                        if (jElementLast.length < 1) {
                            jClonedElement.html(jClonedElement.html().split('{{' + key + '}}').join(value));
                        }
                        jClonedElement.data(key, value);
                    });
                }
                jClonedElement.removeClass('js-mch365-dynamic-placeholder js-mch365-contains-placeholders').show().appendTo(jElementContainer);
                return false;
            });

            mch365.admin.jMainContainer.on('click', '.js-mch365-remove-dynamic-content', function (event) {
                var jElement = jQuery(event.currentTarget);
                if (jElement.hasClass('js-mch365-only-hide')) {
                    jElement.closest('.form-group').hide();
                } else {
                    jElement.closest('.form-group').remove();
                }
            });

            mch365.admin.jMainContainer.on('change', '.js-mch365-checkbox-active-toggle', function (event) {
                var jElement = jQuery(event.target);
                if (jElement.prop('checked')) {
                    jElement.closest('.js-mch365-table-row').removeClass('inactive');
                } else {
                    jElement.closest('.js-mch365-table-row').addClass('inactive');
                }
                jElement.closest('form').submit();
            });

            mch365.admin.jMainContainer.on('click', '.js-mch365-delete', function (event) {
                var jElement = jQuery(event.target);
                mch365.admin.ui.prompt.dialog.confirmDelete({}, function () {
                    jElement.closest('form').submit();
                    jElement.closest('.js-mch365-table-row').remove();
                }, []);
                return false;
            });

            mch365.admin.jMainContainer.on('change', '.js-mch365-input-file-image', function (event) {
                var file = jQuery(event.target).prop('files')[0];
                var image = URL.createObjectURL(file);
                var jElementPreview = jQuery(jQuery(event.target).data('previewElement'));
                jElementPreview.css({
                    'background-image': 'url(\'' + image + '\')'
                });

                jElementPreview.parent().find('input').prop('checked', false);
                jElementPreview.removeClass('mch365-input-file-empty');
            });

            mch365.admin.jMainContainer.on('change', '.js-mch365-file-input-clearbutton', function (event) {
                event.stopImmediatePropagation();
                var jCurrentElement = jQuery(event.currentTarget);
                var jPreviewElement = jCurrentElement.siblings('.js-mch365-preview-element');
                var jInputElement = jQuery('input[id="' + jPreviewElement.data('relInputElement') + '"]');
                jInputElement.val('');
                jPreviewElement.css({
                    'background-image': ''
                });

                if (jCurrentElement.data('previewElements') !== undefined) {
                    jQuery(jCurrentElement.data('previewElements')).css({
                        'background-image': ''
                    });
                }
                jPreviewElement.addClass('mch365-input-file-empty');
            });

            mch365.admin.jMainContainer.on('change', '.js-mch365-input-color', function (event) {
                var jElement = jQuery(event.target);
                var cssClassTextColor = mch365.admin.getTextColorCssClassBasedOnBgColor(jElement.val(), 'e-text-light', 'e-text-dark');
                jQuery(jElement.data('cssContainer')).html(':root { ' + jElement.data('cssVariable') + ': ' + jElement.val() + '; }');
                //jQuery( jElement.data( 'previewElement' ) ).removeClass( 'e-text-light e-text-dark' ).addClass(
                // cssClassTextColor );
            });

            mch365.admin.jMainContainer.on('change', '.js-mch365-datetime-picker', function (event) {
                var jElement = jQuery(event.target);
                mch365.admin.jMainContainer.find('input[id="' + jElement.data('targetInputId') + '"]').val(mch365.admin.form.formatDateTime(jElement.val()));
            });

            mch365.admin.jMainContainer.on('change', mch365.admin.jMainContainer.find('.js-validate-group-of-fields').closest('.form-group').find('input:not(.js-validate-group-of-fields,.js-mch365-exclude-group-validation)'), function (event) {
                var jTargetElement = jQuery(event.target);
                if (jTargetElement.closest('.form-group').find('input:not(.js-validate-group-of-fields,.js-mch365-exclude-group-validation)').filter(':checked').length === 0) {
                    jTargetElement.closest('.form-group').find('.js-validate-group-of-fields').val('');
                } else {
                    jTargetElement.closest('.form-group').find('.js-validate-group-of-fields').val('1');
                }

                if (jTargetElement.closest('.form-group').find('.js-validate-group-of-fields').length > 0) {
                    jTargetElement.closest('.form-group').find('.js-validate-group-of-fields').valid();
                }
            });
            mch365.admin.jMainContainer.on('change', '.js-mch365-input-datetime-group input', function (event) {
                mch365.admin.form.setDateTimeValue(event.currentTarget);
                return false;
            });
        },
        setPaging: function (event) {
            var jElement = jQuery(event.currentTarget),
                jContent = jQuery(event.currentTarget).closest('.js-mch365-content');

            if (jElement.data('pageNum') !== undefined) {
                jContent.find('*[data-input="pageNum"]').val(jElement.data('pageNum'));
            }
            if (jElement.data('pageSize') !== undefined) {
                jContent.find('*[data-input="pageSize"]').val(jElement.data('pageSize'));
            }
            if (!jElement.hasClass('js-link-disabled')) {
                mch365.admin.build();
            }
        },
        sortList: function (event) {
            var jElementSortHandler = jQuery(event.currentTarget);
            if(jElementSortHandler.data('sortBy') === undefined) {
                if (jElementSortHandler.data('sortDir') === 'DESC' || jElementSortHandler.data('sortDir') === '') {
                    jElementSortHandler.attr('data-sort-dir', 'ASC').data('sortDir', 'ASC');
                } else {
                    jElementSortHandler.attr('data-sort-dir', 'DESC').data('sortDir', 'DESC');
                }
            } else {
                var jContent = jElementSortHandler.closest('.js-mch365-content');
                if (jElementSortHandler.data('sortOrder') === 'DESC' || jElementSortHandler.data('sortOrder') === '') {
                    jElementSortHandler.attr('data-sort-order', 'ASC').data('sortOrder', 'ASC');
                } else {
                    jElementSortHandler.attr('data-sort-order', 'DESC').data('sortOrder', 'DESC');
                }

                if (jElementSortHandler.data('sortBy') !== undefined) {
                    jContent.find('*[data-input="sortBy"]').val(jElementSortHandler.data('sortBy'));
                }
                if (jElementSortHandler.data('sortOrder') !== undefined) {
                    jContent.find('*[data-input="sortOrder"]').val(jElementSortHandler.data('sortOrder'));
                }
                mch365.admin.build();
            }
        },
        populateEditFormContainer: function (jElementRow) {
            var jFormContainer = jElementRow.find('.js-mch365-row-form');
            mch365.admin.get(jElementRow.find('.js-mch365-action-form'));
            jFormContainer.removeClass('d-none').addClass('d-block');
            jElementRow.addClass('mch365-form-shown');
            jElementRow.find('.js-mch365-row-content').addClass('d-none');//.removeClass( 'd-flex' );
        },
        formatAsTwoDigits: function (intNumber) {
            return (intNumber < 10 ? '0' : '') + intNumber;
        },
        formatDate: function (date) {
            var intMonth = mch365.admin.form.formatAsTwoDigits(date.getMonth() + 1),
                intDay = mch365.admin.form.formatAsTwoDigits(date.getDate()),
                intYear = date.getFullYear(),
                formattedDate = intDay + '-' + intMonth + '-' + intYear;
            return formattedDate;
        },
        formatDateTime: function (strDatetime) {
            var datetime = new Date(strDatetime),
                intMonth = mch365.admin.form.formatAsTwoDigits(datetime.getMonth() + 1),
                intDay = mch365.admin.form.formatAsTwoDigits(datetime.getDate()),
                intYear = datetime.getFullYear(),
                intHours = mch365.admin.form.formatAsTwoDigits(datetime.getHours()),
                intMinutes = mch365.admin.form.formatAsTwoDigits(datetime.getMinutes()),
                formattedDateTime = intDay + '-' + intMonth + '-' + intYear + ' ' + intHours + ':' + intMinutes;
            return formattedDateTime;
        },
        setDateTimeValue: function (domInput) {
            var jGroupElement = jQuery(domInput).closest('.js-mch365-input-datetime-group');
            var strDateValue = jGroupElement.find('[data-datetime-part="date"]').data('dbValue');
            var strTimeValue = jGroupElement.find('[data-datetime-part="time"]').val();
            var strDatetimeValue = '';
            if (strDateValue.length > 0) {
                if (strTimeValue === undefined) {
                    strTimeValue = '';
                } else if (strTimeValue.length === 0) {
                    strTimeValue = '00:00';
                }
                if (strTimeValue.length === 0) {
                    strDatetimeValue = strDateValue;
                } else {
                    strDatetimeValue = strDateValue + ' ' + strTimeValue;
                }
            }
            jQuery('input[id="' + jGroupElement.data('valueToInputElement') + '"]').val(strDatetimeValue);
        },
        setBehaviors: function (domForm) {
            if (jQuery(domForm).find('.js-mch365-color-picker-container').length > 0) {
                jQuery(domForm).find('.js-mch365-color-picker-container').colorpicker({
                    useAlpha: false,
                    format: 'hex',
                    autoInputFallback: false,
                    autoHexInputFallback: false,
                    extensions: [{
                        input: true
                    }]
                });
            }

            //jQuery('.js-validate-hexcode').rules('add', { regex: '^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$' });


            if (jQuery('.js-mch365-sortable-list').length > 0) {
                e4.require.js(e4.settings.require.sortable, function () {
                    jQuery('.js-mch365-sortable-list').sortable({
                        axis: 'y',
                        handle: '.js-mch365-sortable-handle',
                        stop: function (event, ui) {
                            var jForm = ui.item.find('.js-mch365-sort-form');
                            jForm.find('.js-mch365-input-sort').val(ui.item.index());
                            jForm.submit();
                        }
                    });
                });
            }

            if (mch365.admin.jMainContainer.find('.js-mch365-input-color').length > 0) {
                mch365.admin.jMainContainer.find('.js-mch365-input-color').trigger('change');
            }

            if (mch365.admin.jMainContainer.find('.js-mch365-input-datepicker').length > 0 || mch365.admin.jMainContainer.find('.js-mch365-input-datepicker-single').length > 0) {
                e4.require.js(e4.settings.require.datepicker, function () {
                    mch365.admin.jMainContainer.find('.js-mch365-input-datepicker').each(function (intIndex, domElement) {
                        var jElement = jQuery(domElement);
                        var picker = new Litepicker({
                            element: domElement,
                            singleMode: false,
                            startDate: jElement.data('startDate'),
                            endDate: jElement.data('endDate'),
                            format: 'D\. MMM YYYY',
                            lang: 'da-DK',
                            tooltipText: {
                                one: 'dag',
                                other: 'dage'
                            },
                            setup: function (picker) {
                                picker.on('selected', function (startDate, endDate) {
                                    var jElementInputGroup = jQuery(picker.options.element).closest('.js-mch365-input-group');
                                    jElementInputGroup.find('.js-mch365-input-date-start').val(mch365.admin.form.formatDate(startDate));
                                    jElementInputGroup.find('.js-mch365-input-date-end').val(mch365.admin.form.formatDate(endDate));
                                });
                            },
                            tooltipNumber: function (totalDays) {
                                return totalDays - 1;
                            }
                        });
                    });

                    mch365.admin.jMainContainer.find('.js-mch365-input-datepicker-single').each(function (intIndex, domElement) {
                        var jElement = jQuery(domElement);
                        var picker = new Litepicker({
                            element: domElement,
                            singleMode: true,
                            startDate: jElement.data('date'),
                            format: 'D\. MMM YYYY',
                            lang: 'da-DK',
                            tooltipText: {
                                one: 'dag',
                                other: 'dage'
                            },
                            setup: function (picker) {
                                picker.on('selected', function (startDate) {
                                    jQuery(picker.options.element).data('dbValue', mch365.admin.form.formatDate(startDate));
                                    jQuery(picker.options.element).val(mch365.admin.form.formatDate(startDate));
                                    mch365.admin.form.setDateTimeValue(picker.options.element);
                                    setTimeout(function () {
                                        picker.show();
                                    }, 100);
                                });

                                picker.on('render', function (ui) {
                                    if (jElement.data('date').length > 0) {
                                        jQuery(picker.options.element).data('dbValue', mch365.admin.form.formatDate(picker.options.startDate));
                                    }
                                });
                            },
                            tooltipNumber: function (totalDays) {
                                return totalDays - 1;
                            }
                        });
                    });
                });
            }

            if (jQuery(domForm).hasClass('js-mch365-form')) {
                jQuery(domForm).validate({
                    submitHandler: function (form, event) {
                        mch365.admin.ui.navigationObserver.formIsChangedButNotSaved = false;
                        mch365.admin.submit.form(form, event);
                    }
                });
            }
            if (jQuery(domForm).hasClass('js-mch365-action-form')) {
                jQuery(domForm).validate({
                    submitHandler: function (form, event) {
                        mch365.admin.ui.navigationObserver.formIsChangedButNotSaved = false;
                        mch365.admin.submit.actionForm(form, event);
                    }
                });
            }
        }
    },
    getTextColorCssClassBasedOnBgColor: function (bgColor, lightColor, darkColor) {
        var color = (bgColor.charAt(0) === '#') ? bgColor.substring(1, 7) : bgColor;
        var r = parseInt(color.substring(0, 2), 16); // hexToR
        var g = parseInt(color.substring(2, 4), 16); // hexToG
        var b = parseInt(color.substring(4, 6), 16); // hexToB
        return (((r * 0.299) + (g * 0.587) + (b * 0.114)) > 186) ?
            darkColor : lightColor;
    },
    content: {},
    build: function () {
        jQuery('.js-mch365-form, .js-mch365-content').each(function (intIndex, domElement) {
            mch365.admin.load(domElement);
        });
    },
    ajax: function (jElement, objAjaxSettings, fnCallback) {
        var jqXHR = jQuery.ajax(jQuery.extend({
            type: 'POST',
            method: 'POST',
            dataType: 'json',
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            cache: false,
            beforeSend: function () {
                jQuery('div[for="' + jElement.attr('id') + '"]').addClass('is-loading');
            }
        }, objAjaxSettings));
        jqXHR.done(function (data) {
            if (typeof fnCallback === 'function') {
                fnCallback(data);
            }
            setTimeout(function () {
                jQuery('div[for="' + jElement.attr('id') + '"]').removeClass('is-loading');
            }, 250);
        });
        jqXHR.fail(function (a, b, c) {
            console.warn('Error response => reload page', a, b, c);
            if (a.responseText.indexOf('<table class=\"table\">') !== 0) {
                setTimeout(function () {
                    mch365.admin.ui.prompt.dialog.error({}, function () {
                    }, []);
                }, 0);
            } else {
                setTimeout(function () {
                    var arrPageUrl = window.location.href.split('/');
                    var strPageUrl = '/' + arrPageUrl[arrPageUrl.length - 1];
                    location.href = strPageUrl;
                }, 0);
            }
        });
        jqXHR.always(function (a, b, c) {
            var object = {};
            objAjaxSettings.data.forEach(function (value, key) {
                object[key] = value;
            });
            if (Object.keys(object).length > 0 && jElement.data('redirectUrl') !== undefined) {
                location.href = jElement.data('redirectUrl');
            }
        });
    },
    ajaxGet: function (jElement, objAjaxSettings, fnCallback) {
        var jqXHR = jQuery.ajax(jQuery.extend({
            method: 'GET',
            dataType: 'json',
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            cache: false,
            beforeSend: function () {
                jQuery('div[for="' + jElement.attr('id') + '"]').addClass('is-loading');
            }
        }, objAjaxSettings));
        jqXHR.done(function (data) {
            if (typeof fnCallback === 'function') {
                fnCallback(data);
            }
            setTimeout(function () {
                jQuery('div[for="' + jElement.attr('id') + '"]').removeClass('is-loading');
            }, 250);
        });
        jqXHR.fail(function (a, b, c) {
            console.warn('Error response => reload page', a, b, c);
            setTimeout(function () {
                mch365.admin.ui.prompt.dialog.error({}, function () {
                }, []);
            }, 1000);
        });
        jqXHR.always(function (a, b, c) {
            var object = {};
            objAjaxSettings.data.forEach(function (value, key) {
                object[key] = value;
            });
            if (Object.keys(object).length > 0 && jElement.data('redirectUrl') !== undefined) {
                location.href = jElement.data('redirectUrl');
            }
        });
    },
    refresh: function (event, postData) {
        var domElement = event.target,
            jElement = jQuery(domElement);
        mch365.admin.ajax(jElement, {
            url: jElement.data('feedUrl'),
            data: postData
        }, function (jsonData) {
            mch365.admin.load(jElement.closest('.js-mch365-content')[0]);
        });
    },
    formSubmitted: false,
    post: function (event, postData) {
        var domElement = event.target,
            jElement = jQuery(domElement),
            submitUrl = jElement.data('submitUrl'),
            postUrl = jElement.data('feedUrl');
        if (submitUrl !== undefined) {
            postUrl = submitUrl;
        }
        

        if (postUrl !== undefined) {
            mch365.admin.ajax(jElement, {
                url: postUrl,
                data: postData
            }, function (jsonData) {
                if (submitUrl !== undefined) {
                    mch365.admin.build();
                } else {
                    mch365.admin.formSubmitted = true;
                    mch365.admin.update.set(domElement, jsonData);
                }
            });
        }
    },
    get: function (domElement) {
        var jElement = jQuery(domElement);
        var formData = new FormData();

        if (jElement.closest('.js-mch365-table-row').find('.js-mch365-add-input-to-post').length > 0) {
            jElement.closest('.js-mch365-table-row').find('.js-mch365-add-input-to-post').each(function (intIndex, domElement) {
                var jInputElement = jQuery(domElement);
                if (formData.get(jInputElement.attr('name')) !== null) {
                    formData.delete(jInputElement.attr('name'));
                }
                if (jInputElement.attr('type') === 'checkbox' && jInputElement.is(':checked')) {
                    formData.append(jInputElement.attr('name'), 'on');
                }
                if (jInputElement.attr('type') === 'text' || jInputElement.attr('type') === 'hidden') {
                    formData.append(jInputElement.attr('name'), jInputElement.val());
                }
            });
        }

        mch365.admin.ajaxGet(jElement, {
            url: jElement.data('feedUrl'),
            data: formData,
            method: 'GET'
        }, function (jsonData) {
            mch365.admin.update.set(domElement, jsonData);
        });
    },
    load: function (domElement) {
        var jElement = jQuery(domElement);
        var formData = new FormData();

        if (jElement.find('.js-mch365-content-add-input-to-post').length > 0) {
            jElement.find('.js-mch365-content-add-input-to-post').each(function (intIndex, domElement) {
                var jInputElement = jQuery(domElement);
                if (formData.get(jInputElement.attr('name')) !== null) {
                    formData.delete(jInputElement.attr('name'));
                }
                if (jInputElement.attr('type') === 'checkbox' && jInputElement.is(':checked')) {
                    formData.append(jInputElement.attr('name'), 'on');
                }
                if (jInputElement.attr('type') === 'text' || jInputElement.attr('type') === 'hidden') {
                    formData.append(jInputElement.attr('name'), jInputElement.val());
                }
            });
        }

        if (jElement.closest('.js-mch365-table-row').find('.js-mch365-add-input-to-post').length > 0) {
            jElement.closest('.js-mch365-table-row').find('.js-mch365-add-input-to-post').each(function (intIndex, domElement) {
                var jInputElement = jQuery(domElement);
                if (formData.get(jInputElement.attr('name')) !== null) {
                    formData.delete(jInputElement.attr('name'));
                }
                if (jInputElement.attr('type') === 'checkbox' && jInputElement.is(':checked')) {
                    formData.append(jInputElement.attr('name'), 'on');
                }
                if (jInputElement.attr('type') === 'text' || jInputElement.attr('type') === 'hidden') {
                    formData.append(jInputElement.attr('name'), jInputElement.val());
                }
            });
        }

        mch365.admin.ajax(jElement, {
            url: jElement.data('feedUrl'),
            data: formData
        }, function (jsonData) {
            mch365.admin.update.set(domElement, jsonData);
        });
    },
    setCompleteness: function (domElement) {
        var jElement = jQuery(domElement);
        if (jElement.find('.js-mch365-accordion-container').length > 0) {
            jQuery.each(jElement.find('.js-mch365-accordion-container'), function (intIndex, domElement) {
                var jElement = jQuery(domElement);
                if (jElement.find('.js-mch365-completeness-status-holder').data('dashoffset') !== undefined) {
                    jElement.closest('.js-mch365-placeholder').find('.js-tab-progress-item-count').text(jElement.find('.js-mch365-completeness-status-holder').data('pct'));
                    jElement.closest('.js-mch365-placeholder').find('.js-mch365-progress-ring').css({strokeDashoffset: parseInt(jElement.find('.js-mch365-completeness-status-holder').data('dashoffset'))});
                }
            });
        } else if (jElement.closest('.js-mch365-accordion-container').length > 0) {
            if (jElement.closest('.js-mch365-accordion-container').find('.js-mch365-completeness-status-holder').data('dashoffset') !== undefined) {
                jElement.closest('.js-mch365-accordion-container').find('.js-tab-progress-item-count').text(jElement.closest('.js-mch365-accordion-container').find('.js-mch365-completeness-status-holder').data('pct'));
                jElement.closest('.js-mch365-accordion-container').find('.js-mch365-progress-ring').css({strokeDashoffset: parseInt(jElement.closest('.js-mch365-accordion-container').find('.js-mch365-completeness-status-holder').data('dashoffset'))});
            }
        } else {
            if (jElement.find('.js-mch365-completeness-status-holder').data('dashoffset') !== undefined) {
                jElement.closest('.js-mch365-placeholder').find('.js-tab-progress-item-count').text(jElement.find('.js-mch365-completeness-status-holder').data('pct'));
                jElement.closest('.js-mch365-placeholder').find('.js-mch365-progress-ring').css({strokeDashoffset: parseInt(jElement.find('.js-mch365-completeness-status-holder').data('dashoffset'))});
            }
        }
    },
    update: {
        set: function (domElement, jsonData) {
            if (jQuery(domElement).hasClass('js-mch365-form')) {
                mch365.admin.update.form(domElement, jsonData);
            }
            if (jQuery(domElement).hasClass('js-mch365-action-form')) {
                mch365.admin.update.actionForm(domElement, jsonData);
            }
            if (jQuery(domElement).hasClass('js-mch365-content')) {
                mch365.admin.update.content(domElement, jsonData);
            }
            if (jQuery(domElement).hasClass('js-mch365-void-form')) {
                mch365.admin.update.void(domElement, jsonData);
            }

            mch365.admin.jMainContainer.find('*[class*="js-mch365-"][data-feed-url]').each(function (intIndex, domElement) {
                const jElement = jQuery(domElement);
                if (jElement.closest('.js-mch365-placeholder') != null) {
                    jElement.closest('.js-mch365-placeholder').find('.collapse.show').collapse('hide');
                }
            });
        },
        void: function (domElement, jsonData) {
            console.log('__void__', domElement, jsonData);
        },
        actionForm: function (domElement, jsonData) {
            jQuery(domElement).find('.js-mch365-placeholder').html(jsonData.Html);
            mch365.admin.setCompleteness(domElement);
            mch365.admin.form.setBehaviors(domElement);
        },
        form: function (domElement, jsonData) {
            var jElement = jQuery(domElement);
            jElement.find('.js-mch365-placeholder').html(jsonData.Html);
            mch365.admin.setCompleteness(domElement);
            mch365.admin.form.setBehaviors(domElement);
            if (mch365.admin.formSubmitted) {
                mch365.admin.formSubmitted = false;
                if (jElement.closest('.js-mch365-container').find('.js-mch365-content').length > 0) {
                    mch365.admin.load(jElement.closest('.js-mch365-container').find('.js-mch365-content')[0]);
                }
            }
        },
        content: function (domElement, jsonData) {
            //console.time('Append HTML')
            domElement.querySelector('.js-mch365-placeholder').innerHTML = jsonData.Html;
            //console.timeEnd('Append HTML')
            mch365.admin.setCompleteness(domElement);
            mch365.admin.form.setBehaviors(domElement);
            if (jQuery(domElement).find('.js-mch365-placeholder').find('.js-mch365-form').length > 0) {
                jQuery(domElement).find('.js-mch365-placeholder').find('.js-mch365-form').each(function (intIndex, domElement) {
                    mch365.admin.load(jQuery(domElement)[0]);
                });
            }
            if (jQuery(domElement).find('.js-mch365-placeholder').find('.js-mch365-void-form').length > 0) {
                jQuery(domElement).find('.js-mch365-placeholder').find('.js-mch365-void-form').each(function (intIndex, domElement) {
                    jQuery(domElement).validate({
                        submitHandler: function (form, event) {
                            mch365.admin.submit.form(form, event);
                        }
                    });
                });
            }
        }
    }
};